import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M14.5 14h4.5l2 -2v-6l-6.5 8","key":"svg-0"}],["path",{"d":"M9 19h5l-11 -13v6l6 7","key":"svg-1"}]]

const IconBrandValorant = createReactComponent('outline', 'brand-valorant', 'BrandValorant', __iconNode);

export default IconBrandValorant;